import React, { useState, useContext, useEffect } from 'react';
import { WebSocketContext } from './WebSocketProvider';
import './ChatConfigModal.css';

const ChatConfigModal = ({ isOpen, onClose, currentThreadId, threads, sessionId }) => {
    const { socketRef, refreshThread } = useContext(WebSocketContext);
    const [unhiddenInterval, setUnhiddenInterval] = useState('86400000'); // Default to 1 day (24 hours)

    // Time interval options in milliseconds
    const intervalOptions = [
        { value: '5000', label: '5 seconds' },
        { value: '30000', label: '30 seconds' },
        { value: '3600000', label: '1 hour' },
        { value: '86400000', label: '1 day' },
        { value: '2170691800', label: '25 days' }
    ];

    // Fetch current thread settings when modal opens
    useEffect(() => {
        if (isOpen && currentThreadId) {
            // In the future, we could fetch the current thread settings here
            // For now, we'll just default to 1 day
            const currentThread = threads.find(thread => thread.id === currentThreadId);
            if (currentThread) {
                setUnhiddenInterval(currentThread.config.unhiddenInterval || '86400000');
            }
        }
    }, [isOpen, currentThreadId]);

    const handleIntervalChange = (e) => {
        setUnhiddenInterval(e.target.value);
    };

    const handleSave = () => {
        if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
            // Send request to modify the interval
            socketRef.current.send(JSON.stringify({
                type: 'modify_interval',
                threadId: currentThreadId,
                unhiddenInterval: parseInt(unhiddenInterval, 10)
            }));

            console.log(`Sent request to modify unhidden interval to ${unhiddenInterval} ms`);

            // Request a thread refresh to apply the new interval immediately
            setTimeout(() => {
                refreshThread(currentThreadId, sessionId);
            }, 500); // Short delay to ensure modify_interval is processed first

            onClose();
        } else {
            console.error('WebSocket is not connected');
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <div className="modal chat-config-modal" onClick={(e) => e.stopPropagation()}>
                <h3>Chat Configuration</h3>

                <div className="form-group">
                    <label htmlFor="unhidden-interval">Time until auto-hide:</label>
                    <select
                        id="unhidden-interval"
                        value={unhiddenInterval}
                        onChange={handleIntervalChange}
                        className="interval-select"
                    >
                        {intervalOptions.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="modal-actions">
                    <button onClick={handleSave} className="save-button">Save</button>
                    <button onClick={onClose} className="cancel-button">Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default ChatConfigModal; 